import { Component, Input, OnInit } from '@angular/core';
import { VisaService } from '@modules/payment/services/visa.service';
import { finalize } from 'rxjs/operators';
import { noticeError } from '@app/helpers/new-relic';
import { path } from 'ramda';
import { PaymentService } from '@app/data-services/payment.service';
import { paymentResponseResolver } from '@modules/payment/resolvers/payment-response';
import { HttpStatusCode } from '@modules/shared/constants/http.enum';

const SUCCESS_CODE_ACTION = '000';

@Component({
    selector: 'app-payment-visa-response-authorization',
    providers: [VisaService],
    templateUrl: './payment-visa-response-authorization.component.html',
    styleUrls: ['./payment-visa-response-authorization.component.scss'],
})
export class PaymentVisaResponseAuthorizationComponent implements OnInit {
    isProcessing = false;
    isUnHandleError = false;
    hasNiubizResponse = false;

    @Input() transactionId: string;
    @Input() transactionToken: string;

    visaTransactionResponse: any = {};
    paymentResponse: Partial<NiubizAuthorizationResponse> = {};

    constructor(private _visaService: VisaService, private paymentService: PaymentService) {}

    get isSuccessResponse() {
        const actionCode = path(['visaTransactionResponse', 'actionCode'], this.paymentResponse);
        return actionCode === SUCCESS_CODE_ACTION && this.paymentResponse.statusCode === 200;
    }

    ngOnInit() {
        this.getAuthorization();
    }

    getAuthorization() {
        this.isProcessing = true;
        this._visaService
            .validateTransaction({
                transaction_id: this.transactionId,
                transactionToken: this.transactionToken,
            })
            .pipe(
                finalize(() => {
                    this.isProcessing = false;
                    this.paymentService.removeAllItems();
                })
            )
            .subscribe(
                (response: any) => {
                    this.paymentResponse = paymentResponseResolver({
                        raw: response,
                        statusCode: 200,
                    });
                    this.hasNiubizResponse = true;
                },
                (responseError) => {
                    console.error(responseError);
                    noticeError(responseError);
                    if (responseError.status === HttpStatusCode.BadRequest) {
                        this.paymentResponse = paymentResponseResolver({
                            raw: responseError.error,
                            statusCode: responseError.status,
                        });
                        this.hasNiubizResponse = true;
                    } else {
                        this.isUnHandleError = true;
                    }
                }
            );
    }
}
